"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "predoi": {
    "4ee32768": [{
      "hkey": "b68f2542",
      "slug": "casere-knappenegg",
      "name": "Casere-Knappenegg",
      "primary": true,
      "skipSearch": false
    }],
    "casere": [{
      "hkey": "b68f2542",
      "slug": "casere-knappenegg",
      "name": "Casere-Knappenegg",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;